export namespace HomeActions {
    export class Load {
        public static readonly type = "[Home] Load";
    }
}
